import React from 'react';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger
} from '@core-ui/Components/ui/dialog.tsx';
import { useTranslation } from 'react-i18next';
import { Button } from '@core-ui/Components/ui/button.tsx';

interface DeleteIntegrationAccountDialogProps {
  trigger: React.JSX.Element;
  deleteCallback: () => void;
}

/**
 * A generic modal to delete an integration account, contains standard messages for any integration account.
 */
export function DeleteIntegrationAccountDialog ({ trigger, deleteCallback }: DeleteIntegrationAccountDialogProps): React.JSX.Element {
  const { t } = useTranslation();

  const dialogContainerStyles = `rounded-2xl shadow-2xl w-full max-w-lg text-foreground border border-border',
    'data-[state=open]:animate-in data-[state=open]:fade-in-0', 'data-[state=closed]:animate-out data-[state=closed]:fade-out-0',
    '[&_div[data-radix-dialog-overlay]]:bg-black/60', '[&_div[data-radix-dialog-overlay]]:backdrop-blur-sm`;
    
  return (
    <Dialog>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className={`grid gap-6 ${dialogContainerStyles}`}>
        <DialogHeader className="flex justify-center rounded-xl px-2 mt-4 transition-colors">
          <DialogTitle className="text-center text-lg">{t('settings.integrationsPages.deleteAccountModal.title')}</DialogTitle>
          <div className="flex justify-center rounded-xl p-2 mt-4 transition-colors text-md">
            <p className="text-center">{t('settings.integrationsPages.deleteAccountModal.deleteWarning')}</p>
          </div>
          <DialogClose className="flex justify-center gap-4 mt-4">
            <Button className="cursor-pointer" variant="destructive" onClick={deleteCallback}>{t('settings.integrationsPages.deleteAccountModal.deleteAccount')}</Button>
            <Button className="cursor-pointer" variant="outline" >{t('settings.integrationsPages.cancel')}</Button>
          </DialogClose>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}